{
  "nl": {
    "dataProtection": {
      "copyright": "Houd rekening met auteursrechten wanneer je externe inhoud gebruikt",
      "data": "Deel nooit gevoelige of persoonlijke informatie met een AI-toepassing",
      "deletionPolicy": {
        "content": "Vanwege privacyvoorschriften worden alle inhoud van leerlingen na 365 dagen verwijderd."
      },
      "pupils": "Voeg geen inhoud met persoonlijke gegevens van jou of anderen toe",
      "students": "Gebruik geen inhoud met persoonlijke gegevens van je leerlingen",
      "worksheets": "Geen zorgen: jouw werkbladen blijven behouden."
    }
  }
}
